export const HOST_PATH = "http://moodyfoody.dev-portal.com/";
export const API_PATH = "wp-json/wp/v2/posts";



// WEBPACK FOOTER //
// ./src/constants.js